import type { Page } from "@pdfking/renderer"
import type { AnyGUID, AsyncSequence } from "@pdfking/tfunc"

import type { GeneratedFile } from "../files/cached/GeneratedFile"
import type { RemoteFile } from "../files/cached/RemoteFile"
import type { SinglePageImage } from "../files/cached/SinglePageImage"
import type { SinglePagePdf } from "../files/cached/SinglePagePdf"
import type { ContentType } from "../files/ContentType"
import type { VirtualFile } from "../files/VirtualFile"
import type { FilePlottingContext } from "../tasks/options/TaskPlotOptions"
import type { TrackingCallback } from "../tasks/tracking/TrackingCallback"
import type { PdfEngineOptions } from "./PdfEngineOptions"
/**
 * Main PDF engine interface for processing PDF documents
 */
export type PdfEngine = {
  readonly config: PdfEngineOptions
  readonly PlotPdf: (
    plot: Page,
    context: Partial<FilePlottingContext>,
    task_id: AnyGUID | undefined
  ) => Promise<SinglePagePdf>
  readonly SplitPdf: (file: VirtualFile) => AsyncGenerator<SinglePagePdf>
  readonly RasterizePdf: (file: VirtualFile) => AsyncGenerator<SinglePageImage>
  readonly ZipFiles: (
    files: AsyncSequence<[string, VirtualFile]>,
    task_id: AnyGUID | undefined
  ) => Promise<GeneratedFile>
  readonly MergePdf: (
    files: AsyncSequence<[number, number, SinglePagePdf] | VirtualFile>,
    task_id: AnyGUID | undefined
  ) => Promise<GeneratedFile>
  readonly GenerateFile: (
    stream: AsyncSequence<Blob>,
    content_type: ContentType
  ) => Promise<GeneratedFile>

  readonly CreateRemoteFile: (file: Partial<RemoteFile>) => Promise<RemoteFile>
  readonly RequestContent: (
    file: VirtualFile,
    emit?: TrackingCallback
  ) => Promise<Response>
}
